import React, { useEffect } from "react";
import { getRemoteParticipants, PARTICIPANT_STATUS } from "..";
import { translate } from "../../i18n";
import { connect } from "../../redux";

function ChatParticipantList({ 
    t, participant, recipientList, handlerRecipentList, handlerParticipant
}) {   
    useEffect(() => {        
        recipientList.forEach((name, member_id) => {
            const prevP = participant && participant.get(member_id);

            if (!prevP) handlerRecipentList(member_id);
            
        });
    }, [participant]);

    return (
        <>
            <dl className="close nonSelect" onClick={() => handlerParticipant(false)}> {t("dialog.close")} </dl>
            <div className="list">
                { participant && [ ...participant.values() ].map(p =>  {
                    const isCheck = recipientList.has(p.user_uuid);
                    const handlerChoice = () => handlerRecipentList(p.user_uuid, p.nickname);

                    return (
                        <dl key={p.user_uuid} className="nonSelect" onClick={handlerChoice}>
                            <span className={`icoImg check check_${isCheck}`}></span>
                            <span>{p.nickname}</span>
                        </dl>
                    );
                }) }
            </div>
        </>
    )
}

function _mapStateToProps(state, ownProps) {
    const remoteParticipants = ownProps.participant ? ownProps.participant : getRemoteParticipants(state);
    
    return { 
        participants: remoteParticipants
    }
}

export default translate(connect(_mapStateToProps)(ChatParticipantList));